import React from 'react'
import { MemberTrendDirection } from '@vacationtracker/shared/types/team-energy'

interface ISparklineProps {
  scores: number[]
  trendDirection: MemberTrendDirection | null
  width?: number
  height?: number
}

const Sparkline: React.FC<ISparklineProps> = ({ scores, trendDirection, width = 88, height = 28 }) => {
  if (!scores || scores.length < 2) {
    return <svg className="te-sparkline" width={width} height={height} aria-hidden="true" />
  }

  const padX = 3
  const padY = 2
  const maxX = width - padX
  const minX = padX
  const drawHeight = height - padY * 2

  const xStep = scores.length === 1 ? 0 : (maxX - minX) / (scores.length - 1)

  const points = scores.map((s, i) => {
    const clamped = Math.max(0, Math.min(100, s))
    const x = minX + i * xStep
    const y = padY + ((100 - clamped) / 100) * drawHeight
    return { x, y }
  })

  const linePath = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(' ')

  const first = points[0]
  const last = points[points.length - 1]
  const baselineY = height - padY
  const areaPath = `${linePath} L ${last.x.toFixed(1)} ${baselineY.toFixed(1)} L ${first.x.toFixed(1)} ${baselineY.toFixed(1)} Z`

  const trendClass = (trendDirection ?? 'STABLE').toLowerCase()

  return (
    <svg className={`te-sparkline te-sparkline--${trendClass}`} width={width} height={height}>
      <path d={areaPath} fill="currentColor" fillOpacity={0.18} stroke="none" />
      <path d={linePath} fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={last.x} cy={last.y} r={2.2} fill="currentColor" />
    </svg>
  )
}

export default Sparkline
